import {JackpotBetWinHighlightAmountMRGreenBox} from "./jackpot-bet-win-highlight-amount.mrgreen.box";

export const JackpotBetWinHighlightAmountMRGreenCisBox = JackpotBetWinHighlightAmountMRGreenBox; 